import React from 'react';
import PropTypes from 'prop-types';
import './TrashIcon.css';

function TrashIcon({ filled, name, disabled }) {
  return (
    <i
      className={`fa fa-trash ${disabled ? 'fa-disabled' : ''} ${filled
        ? 'fa-highlight'
        : ''}`.trim()}
      aria-hidden="true"
      title={`Delete this ${name}`}
    />
  );
}

TrashIcon.propTypes = {
  filled: PropTypes.bool,
  name: PropTypes.string,
  disabled: PropTypes.bool
};

export default TrashIcon;



// WEBPACK FOOTER //
// ./src/components/Icon/TrashIcon/index.js